var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_610)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.401 1.79446L13.4774 2.87102C13.7607 3.15435 13.7607 3.61786 13.4774 3.90119L12.6106 4.76802C12.8497 5.21456 13.0322 5.69589 13.1483 6.20262H14.2712C14.672 6.20262 14.9999 6.5305 14.9999 6.93114V8.45351C14.9999 8.85427 14.672 9.18216 14.2712 9.18216H13.0458C12.8955 9.67814 12.6805 10.146 12.4105 10.576L13.2054 11.3707C13.4888 11.6542 13.4888 12.1178 13.2054 12.401L12.129 13.4775C11.8457 13.7607 11.3821 13.7607 11.0989 13.4775L10.2319 12.6106C9.78552 12.8498 9.30408 13.0324 8.79724 13.1484V14.2713C8.79724 14.672 8.46948 14.9999 8.06873 14.9999H6.54651C6.14575 14.9999 5.81787 14.672 5.81787 14.2713V13.0459C5.3219 12.8955 4.854 12.6805 4.42419 12.4105L3.62939 13.2054C3.34583 13.4887 2.88232 13.4887 2.599 13.2054L1.52258 12.129C1.23926 11.8457 1.23926 11.3821 1.52258 11.0988L2.38953 10.2319C2.15027 9.78544 1.96765 9.30411 1.85181 8.79738H0.728516C0.327881 8.79738 0 8.46962 0 8.06886V6.54649C0 6.14573 0.327881 5.81797 0.728516 5.81797H1.95398C2.10437 5.32199 2.31934 4.85408 2.58923 4.42414L1.79443 3.62945C1.51111 3.346 1.51111 2.88237 1.79443 2.59916L2.87097 1.52261C3.1543 1.23928 3.6178 1.23928 3.90112 1.52261L4.76794 2.38944C5.21448 2.15018 5.6958 1.96756 6.20264 1.85159V0.72865C6.20264 0.327886 6.53052 0 6.93115 0H8.45349C8.85413 0 9.18201 0.327886 9.18201 0.72865V1.95377C9.6781 2.10404 10.1461 2.31901 10.5763 2.58903L11.3706 1.79446C11.6542 1.51113 12.1177 1.51113 12.401 1.79446ZM7.5 4.50691C9.15283 4.50691 10.493 5.84726 10.493 7.5C10.493 9.15261 9.15283 10.4931 7.5 10.4931C5.84729 10.4931 4.50696 9.15274 4.50696 7.5C4.50696 5.84726 5.84729 4.50691 7.5 4.50691Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.dc9ab5762975b89b2f9a53e81833cb83.svg";
export { ForwardRef as ReactComponent };